// extracted by mini-css-extract-plugin
module.exports = {"avaxType":"Friends_avaxType__3Vz5Z","nftImg":"Friends_nftImg__UVMFV","img":"Friends_img__2gWJn","flexContainer":"Friends_flexContainer__1ysCm","flexItem":"Friends_flexItem__1SwIL"};